import React, { useEffect, useState, useCallback } from 'react';
import GiftDetailsCard from './Components/GiftDetailsCard';
import { useLocation } from 'react-router-dom';
import { toast } from 'react-toastify';
import { getgiftDetailAction } from './APIs/action';
import { CircularProgress } from '@mui/material';

const RewardDetails = () => {
  const location = useLocation();
  const giftid = location.state?.gift_id || {};
  const selectedCompanyEntity = location.state?.selectedCompanyEntity || {};
  const selectedManufacturer = location.state?.selectedManufacturer || {};
  const type = location.state?.type || {};
  const [loading, setLoading] = useState(false);
  const [giftData, setGiftData] = useState({});

  const fetchGiftDetails = async() => {
    setLoading(true);
    const { data, message, error } = await getgiftDetailAction(giftid, type, selectedCompanyEntity);
    setLoading(false);
    if (!error) {
      setGiftData(data);
    } else {
      toast.error(message);
    }
  }

  useEffect(() => {
    if (giftid && selectedCompanyEntity) {
      fetchGiftDetails();
    }
  }, [giftid, selectedCompanyEntity]);
  if (loading) {
    return (
      <div
        style={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          height: '100vh',
        }}
      >
        <CircularProgress />
      </div>
    );
  }
  return (
    <div style={{ padding: '20px' }}>
      <GiftDetailsCard
        data={giftData}
        type={type}
        onRefresh={fetchGiftDetails}
        user_esi_id={selectedCompanyEntity}
        selectedManufacturer={selectedManufacturer}
      />
    </div>
  );
};

export default RewardDetails;
